class VideoBackground {
  constructor(el) {
    this.$el = $(el);
    this.$video = this.$el.find("video");
    this.videoUrl = this.$video.data("src");

    if (this.$video.length) {
      this.init();
    }
  }

  init() {
    this.setupVideo();
    this.lazyLoadVideo();
  }

  setupVideo() {
    // Set video attributes for background behavior
    this.$video
      .prop({
        muted: true,
        loop: true,
        playsinline: true,
        defaultMuted: true,
        autoplay: true,
      })
      .css({
        position: "absolute",
        width: "100%",
        height: "100%",
        objectFit: "cover",
      });
  }

  lazyLoadVideo() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.$video.prop("src")) {
              this.$video.prop("src", this.videoUrl);
              this.$video[0].load();
            }

            this.$video[0].play().catch(() => {});

            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "50px 0px",
        threshold: 0.1,
      }
    );

    observer.observe(this.$el[0]);
  }
}

export default (() => {
  const $els = $(".lr-content-video__video-wrapper");
  $els.each((_, el) => {
    new VideoBackground(el).init();
  });
})();
// console.log("test");